import React from "react";
import displayName from "../displayName";
import LocaleProvider from "./LocaleProvider";

const WithLocale = ({ resources, ...options } = {}) => Component => {
	const ComponentWithLocale = props => {
		return (
			<LocaleProvider resources={Component.resources ?? resources} {...options}>
				<Component {...props} />
			</LocaleProvider>
		);
	};

	Object.assign(ComponentWithLocale, Component);
	ComponentWithLocale.displayName = displayName("WithLocale", Component);

	return ComponentWithLocale;
};

export default WithLocale;
